var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_12519_21376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_854_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5555 0C5.04154 0 0.555542 4.486 0.555542 10C0.555542 15.514 5.04154 20 10.5555 20C16.0695 20 20.5555 15.514 20.5555 10C20.5555 4.486 16.0695 0 10.5555 0ZM10.5555 18.8889C5.65421 18.8889 1.66665 14.9014 1.66665 10C1.66665 5.09861 5.65421 1.11111 10.5555 1.11111C15.4569 1.11111 19.4444 5.09861 19.4444 10C19.4444 14.9014 15.4569 18.8889 10.5555 18.8889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7863 15.6665V4.33398L8.89453 10.0003L15.7863 15.6665ZM14.6753 13.3145L10.6441 10.0003L14.6753 6.68598V13.3145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.32483 15.2782H8.65816V4.72266H5.32483V15.2782ZM6.43594 5.83377H7.54705V14.1671H6.43594V5.83377Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.555542)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.e028f904c441aa9df76f73cf593c2c9c.svg";
export { ForwardRef as ReactComponent };